import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
type CTAButtonProps = {
  to?: string;
  href?: string;
  children: React.ReactNode;
  variant?: 'primary' | 'ghost';
  className?: string;
};
const base = 'group inline-flex items-center gap-2 rounded-full px-6 py-3.5 text-sm font-semibold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 focus-visible:ring-offset-2 focus-visible:ring-offset-[#0a0a0a]';
export function CTAButton({
  to = '/contact',
  href,
  children,
  variant = 'primary',
  className = ''
}: CTAButtonProps) {
  const styles = variant === 'primary' ? 'bg-emerald-500 text-[#0a0a0a] hover:bg-emerald-400' : 'border border-[#2a2a2a] text-neutral-200 hover:border-emerald-500/60 hover:text-white';
  const content = <>
      {children}
      <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" data-id="element-195" data-mp="3cnrm4lor05lp" />
    </>;
  if (href) {
    return <a href={href} className={`${base} ${styles} ${className}`} data-id="element-196" data-mp="19ahd8tgfwqzt">
        {content}
      </a>;
  }
  return <Link to={to} className={`${base} ${styles} ${className}`} data-id="element-197" data-mp="1dartr01uyzsx">
      {content}
    </Link>;
}